"use client"

import { useState, useEffect } from "react"
import { getInvoices } from "../utils/getInvoices"

interface Invoice {
  amount: number
  date: string
  currency: string
  id: string
  status: string
  paid: boolean
}

export default function BillingHistorySection() {
  const [invoices, setInvoices] = useState<Invoice[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function fetchInvoices() {
      try {
        const data = await getInvoices()
        setInvoices(data.invoices)
        setError(null)
      } catch (err) {
        setError("Failed to fetch invoices")

      } finally {
        setIsLoading(false)
      }
    }

    fetchInvoices()
  }, [])

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  if (error) {
    return <div className="alert alert-danger">{error}</div>
  }

  return (
    <div className="card">
      <div className="card-header bg-white">
        <h2 className="card-title h5 mb-0">Billing History</h2>
      </div>
      <div className="card-body p-0">
        <div className="table-responsive">
          <table className="table table-hover table-striped mb-0">
            <thead>
              <tr className="bg-light">
                <th className="px-4 py-3 border-0">Charge</th>
                <th className="px-4 py-3 border-0">Status</th>
                <th className="px-4 py-3 border-0">Amount</th>
                <th className="px-4 py-3 border-0">Date</th>
              </tr>
            </thead>
            <tbody>
              {invoices.map((invoice, index) => (
                <tr key={index}>
                  <td className="px-4 py-3">{invoice.id}</td>
                  <td className="px-4 py-3">
                    <span
                      className={`badge ${
                        invoice.paid ? "bg-success" : invoice.status === "open" ? "bg-warning" : "bg-danger"
                      }`}
                    >
                      {invoice.paid ? "Paid" : invoice.status === "open" ? "Pending" : "Failed"}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    {invoice.amount.toFixed(2)} {invoice.currency.toUpperCase()}
                  </td>
                  <td className="px-4 py-3">{new Date(invoice.date).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
;<style>{`
  .card {
    border: none;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    border-radius: 0.5rem;
  }
  .card-header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  }
  .table th {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.05em;
  }
  .table td {
    font-size: 0.875rem;
    vertical-align: middle;
  }
  .badge {
    font-weight: 500;
    padding: 0.5em 0.75em;
    font-size: 0.75rem;
  }
`}</style>

